import { APP_PREFIX_PATH } from '@/constants/route.constant'
import { NAV_ITEM_TYPE_ITEM, NAV_ITEM_TYPE_TITLE } from '@/constants/navigation.constant'

const generalNavigationConfig = [
   /* {
        key: 'account',
        path: '',
        title: '',
        translateKey: '',
        icon: '',
        type: NAV_ITEM_TYPE_TITLE,
        permissions: [],
        subMenu: [
            {
                key: 'account/order',
                path: `${APP_PREFIX_PATH}/account/order`,
                title: 'مشاهده سفارش',
                translateKey: 'مشاهده سفارش',
                icon: '',
                type: NAV_ITEM_TYPE_ITEM,
                permissions: [],
                subMenu: []
            }
        ]
    }*/
]

export default generalNavigationConfig
